import { Divider } from "@mui/material";
import type { FC, KeyboardEvent, MouseEvent } from "react";

import {
  formatPhoneLocal,
  onActivateKeyDown,
  useDrawers,
  type IPassengerInfo,
} from "@ryde/shared";

import { RidesCalendarPassengersTooltipWrapper } from "./rides-calendar.styled";

interface IPassengersTooltipProps {
  passengersInfo: IPassengerInfo[];
}

export const RidesCalendarPassengersTooltip: FC<IPassengersTooltipProps> = ({
  passengersInfo,
}) => {
  const { openEditFormDrawer } = useDrawers();

  const openPassenger = (
    e: MouseEvent | KeyboardEvent,
    passengerId: number | undefined,
  ): void => {
    e.stopPropagation();
    if (!passengerId) {
      return;
    }
    openEditFormDrawer({ id: passengerId, entity: "passenger" });
  };

  return (
    <RidesCalendarPassengersTooltipWrapper>
      {passengersInfo.map(passenger => {
        const { id, firstName, lastName, code, unitName, phone } = passenger;
        const fullName = [firstName, lastName].filter(Boolean).join(" ");
        return (
          <div
            key={id}
            className="rc-passengers-tooltip__row"
            data-e2e={`rides-calendar-passenger-${id}`}
          >
            {fullName && (
              <span
                role="button"
                tabIndex={0}
                onClick={e => openPassenger(e, id)}
                onKeyDown={onActivateKeyDown(e => openPassenger(e, id))}
                className="rc-passengers-tooltip__item rc-passengers-tooltip__item--name"
              >
                {fullName}
              </span>
            )}
            {code && (
              <>
                <Divider
                  orientation="vertical"
                  className="rc-passengers-tooltip__divider"
                  flexItem
                />
                <span className="rc-passengers-tooltip__item">#{code}</span>
              </>
            )}
            {unitName && (
              <>
                <Divider
                  orientation="vertical"
                  className="rc-passengers-tooltip__divider"
                  flexItem
                />
                <span className="rc-passengers-tooltip__item">{unitName}</span>
              </>
            )}
            {phone && (
              <>
                <Divider
                  orientation="vertical"
                  className="rc-passengers-tooltip__divider"
                  flexItem
                />
                <span className="rc-passengers-tooltip__item">
                  {formatPhoneLocal(phone)}
                </span>
              </>
            )}
          </div>
        );
      })}
    </RidesCalendarPassengersTooltipWrapper>
  );
};
